import {ChangeEvent, FC, MouseEvent, useRef} from 'react'
import {names} from 'shared/lib'
import {Pen} from 'shared/ui/icons'
import {Loader} from 'shared/ui/loader'
import styles from './styles.module.scss'

type EditButtonProps = {
  className?: string
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  isLoading?: boolean
}

export const EditButton: FC<EditButtonProps> = ({
  className,
  onChange,
  isLoading
}) => {
  const editRef = useRef<HTMLInputElement | null>(null)

  return (
    <div className={names(styles.editButton, className)}>
      {isLoading ?
        <Loader innerColor='white' />
        :
        <>
          <div
            className={styles.iconButton}
            onClick={(event) => {
              event.stopPropagation()
              editRef.current?.click()
            }}
          >
            <Pen />
          </div>
          <input
            ref={editRef}
            type='file'
            accept='image/*'
            onChange={onChange}
            className={styles.input}
            onClick={(e: MouseEvent<HTMLInputElement>) => e.stopPropagation()}
          />
        </>
      }
    </div>
  )
}
